import React from 'react';
import Aux from '../../../hoc/Aux';

const search = (props) => {
    return (
        <Aux>
            <h1>How to Use the Collections</h1>
            {/* <img src={sample}></img> */}
        </Aux>
    )
}

export default search;